export default __webpack_public_path__ + "static/media/task-bundles-table-empty.df63287b.svg";